import { TREND_TOOLS } from '@/toolSelection/investigate.constants';
import { type ModelDehydratedState, ModelStore } from '@/tools/models/model.store';
import type { ModelOutputV1 } from '@/sdk/model/ModelOutputV1';

export type ToolModelDehydratedState = ModelDehydratedState;

/**
 * Store for models within the tool pane.
 * Models can be created and edited in multiple places (e.g. tool pane, scaling tables)
 * so we need a dedicated store for the model tool to avoid conflicts with other places.
 */
export class ToolModelStore extends ModelStore {
  static readonly storeName = 'sqToolModelStore';

  override dehydrate(): ToolModelDehydratedState {
    return super.dehydrate();
  }

  override rehydrate(dehydratedState: Partial<ToolModelDehydratedState>): void {
    super.rehydrate(dehydratedState);
  }

  protected override readonly handlers = {
    ...this.baseHandlers,
    TOOL_MODEL_RESET_MODEL: this.resetModel,
    TOOL_MODEL_SET_MODEL: this.setModel,
    TOOL_MODEL_SET_FEATURE_TO_EDIT_ID: this.setFeatureToEditId,
    TOOL_MODEL_SET_INSTANCE_TO_EDIT_ID: this.setInstanceToEditId,
    TOOL_MODEL_SET_MODEL_OUTPUT: this.setModelOutput,
    TOOL_MODEL_SET_VERSION_STATE: this.setVersionState,
    MODEL_TOOL_REHYDRATE_FOR_EDIT: (payload: { type: string; modelData: ModelOutputV1; instanceId: string }) => {
      if (payload.type !== TREND_TOOLS.MODEL_APPLY) {
        return;
      }
      this.setModelOutput({ modelOutput: payload.modelData });
      this.setInstanceToEditId({ instanceToEditId: payload.instanceId });
    },
  };
}
